
import StepsRequestAccess from "./StepsRequestAccess";
import {REQUEST_ACCESS_STEP_MODEL} from "../Model/Model";
/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 *
 */
const StepContainerRequestAccess = ({
    t,
    steps,
    navigate,
    visitorList,
    setVisitorList,
    employeeList,
    setEmployeeList,
    emptyFields,
    activeStep,
    setActiveStep,
    requestAccessItem,
    photoPickerFile,
    setPhotoPickerFile,
    showLoader,
    handleChange,
    userData,
    setUserData,
    handleChangeVisitor,
    emptyFieldsVisitor,
    isValidEmail,
    isValidPhoneNumber,
    isValidDocumentId,
    handleEmailChange,
    handlePhoneNumberChange,

    isValidEmailFindVisitor,
    setIsValidEmailFindVisitor,
    email,
    setEmail
}) => {

    const { renderFindBySelfSteps, renderFindBySelfCreateVisitorSteps, renderIAmNewHereSteps } = StepsRequestAccess({
        t,
        navigate,
        visitorList,
        setVisitorList,
        employeeList,
        setEmployeeList,
        emptyFields,
        activeStep,
        setActiveStep,
        requestAccessItem,
        photoPickerFile,
        setPhotoPickerFile,
        showLoader,
        handleChange,
        userData,
        setUserData,
        handleChangeVisitor,
        emptyFieldsVisitor,
        isValidEmail,
        isValidPhoneNumber,
        isValidDocumentId,
        handleEmailChange,
        handlePhoneNumberChange,

        isValidEmailFindVisitor,
        setIsValidEmailFindVisitor,
        email,
        setEmail
    });

    const renderStepContent = () => {
        switch (steps?.NAME) {
            case REQUEST_ACCESS_STEP_MODEL.FIND_MYSELF.NAME:
                return renderFindBySelfSteps();
            case REQUEST_ACCESS_STEP_MODEL.FIND_MYSELF_CREATE_VISITOR.NAME:
                return renderFindBySelfCreateVisitorSteps();
            case REQUEST_ACCESS_STEP_MODEL.I_AM_NEW_HERE.NAME:
                return renderIAmNewHereSteps();
            default:
                return null;
        }
    };

    return <>{ renderStepContent() }</>;
};

export default StepContainerRequestAccess
